/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function ColorBlindTritanomaly(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'ColorBlindTritanomaly',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 16 * scale,
      viewBox: '0 0 16 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M14.328 13.828a4 4 0 0 0 1.132-2.263l-3.395 3.395a4 4 0 0 0 2.263-1.132m-3.864 1.036 4.9-4.9a4 4 0 0 0-.584-1.254l-5.57 5.57c.388.272.813.466 1.254.584M8.34 13.453a4 4 0 0 1-.64-1.2l5.054-5.052c.425.14.831.353 1.199.639zm-.832-2.703 3.742-3.742a4 4 0 0 0-2.578 1.164 4 4 0 0 0-1.164 2.578","fill":"#2496FF"}),createElement('path', {"d":"M6.982 7.863a4 4 0 1 0 0 6.274A5.47 5.47 0 0 1 6 11c0-1.166.363-2.247.982-3.137","fill":"#2FC862"}),createElement('path', {"d":"M11.967 5.516a4 4 0 1 0-5.473 3.19 5.5 5.5 0 0 1 5.473-3.19","fill":"#FF424D"}))
}
